import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule, Meta } from '@angular/platform-browser';
import {
    APP_INITIALIZER,
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    VERSION,
} from '@angular/core';
import {
    HTTP_INTERCEPTORS,
    HttpClient,
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LayoutComponent } from './layout/layout.component';
import { MaterialModule } from './material.module';
import { NavigationComponent } from './layout/navigation/navigation.component';
import { PageNotFoundComponent } from './layout/page-not-found/page-not-found.component';
import { LoginComponent } from './login/login.component';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { ComponentsModule } from './components/components.module';
import { AppService } from './app.service';
import { LocalStorageService } from './shared/services/local-storage.service';
import { WINDOW_INJECTION_TOKEN } from './shared/tokens/window.injection.token';
import { TokenInterceptor } from './auth/token.interceptor';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { registerLocaleData } from '@angular/common';

import localees from '@angular/common/locales/es';
import localefi from '@angular/common/locales/fi';
import localeen from '@angular/common/locales/en';
import localenl from '@angular/common/locales/nl';
import localefr from '@angular/common/locales/fr';
import localezh_Hans from '@angular/common/locales/zh-Hans';
import localezh_Hant from '@angular/common/locales/zh-Hant';
import localede from '@angular/common/locales/de';
import localeja from '@angular/common/locales/ja';
import localenn from '@angular/common/locales/nn';
import localeda from '@angular/common/locales/da';
import localenb from '@angular/common/locales/nb';
import localept from '@angular/common/locales/pt';
import localesv from '@angular/common/locales/sv';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AppInitService } from './app.init.service';
import { SanitizeHtmlModule } from './safe.pipe.module';

registerLocaleData(localees, 'es');
registerLocaleData(localefi, 'fi');
registerLocaleData(localeen, 'en');
registerLocaleData(localenl, 'nl');
registerLocaleData(localefr, 'fr');
registerLocaleData(localezh_Hans, 'zh-Hans');
registerLocaleData(localezh_Hant, 'zh-Hant');
registerLocaleData(localede, 'de');
registerLocaleData(localeja, 'ja');
registerLocaleData(localept, 'pt');
registerLocaleData(localesv, 'sv');
registerLocaleData(localenn, 'nn');
registerLocaleData(localeda, 'da');
registerLocaleData(localenb, 'nb');

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function initializeApp(appInitService: AppInitService) {
    return () => appInitService.initApp();
}
@NgModule({
    declarations: [
        AppComponent,
        LayoutComponent,
        NavigationComponent,
        PageNotFoundComponent,
        LoginComponent,
        OnboardingComponent,
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        BrowserModule,
        ComponentsModule,
        BrowserAnimationsModule,
        FormsModule,
        MaterialModule,
        AppRoutingModule,
        ReactiveFormsModule,
        NgxSkeletonLoaderModule,
        SanitizeHtmlModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [AppInitService],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        Meta,
        AppService,
        LocalStorageService,
        { provide: WINDOW_INJECTION_TOKEN, useValue: window },
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class AppModule {}
